<template>
  <div class="zrqSelectPage">
    <p class="currentBox clearfix">
      当前责任区：<span>{{ selecedZrq }}</span>
    </p>
    <div class="selectBox">
      <p class="selectTit">切换责任区：</p>
      <ul class="selectList">
        <li
          v-for="(item, index) in dataList"
          :key="index"
          @click="selecedActive(item, index)"
          :class="['listInfo', checkSeleced == index ? 'active' : '']"
        >
          <p class="infoTit">{{ item.zqName }}</p>
          <van-cell-group class="infoDetail">
            <van-field
              label="责任区级别"
              :value="getLevelName(item.level)"
              readonly
              class="vanCell"
            />
            <van-field
              :label="item.postName"
              rows="1"
              autosize
              type="textarea"
              :value="item.userNames ? item.userNames : '/'"
              readonly
              class="vanCell moreText"
            />
          </van-cell-group>
          <span class="selected"
            ><van-icon name="success" class="selectIcon"
          /></span>
        </li>
      </ul>
    </div>
    <div class="btnBox">
      <van-button type="danger" size="large" @click="cencalSelectVal"
        >取消</van-button
      >
      <van-button type="primary" size="large" @click="saveSelectVal"
        >确认</van-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "zrqSelect",
  data() {
    return {
      uid: "",
      selecedZrq: "",
      dataList: [],
      checkSeleced: 0,
      emitData: {
        zrqName: "",
        objid: "",
        type: "",
        level: "",
        zqCode: "",
      },
    };
  },
  props: {
    zrqData: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    if (this.zrqData.uid && this.zrqData.objid) {
      this.getSelectList();

      this.selecedZrq = this.emitData.zrqName;
    }
  },
  methods: {
    getSelectList() {
      let _this = this;
      _this.$api.universal.dutyArea
        .getDutyAreaList(_this.zrqData.uid)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.dataList = res.data;
            _this.dataList.forEach((item, index) => {
              if (this.zrqData.objid == item.objid) {
                this.checkSeleced = index;
                this.selecedZrq = item.zqName;
              }
            });
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selecedActive(item, index) {
      this.selecedZrq = item.zqName;
      this.emitData.zrqName = item.zqName;
      this.emitData.objid = item.objid;
      this.emitData.type = item.type;
      this.emitData.level = item.level;
      this.emitData.zqCode = item.zqCode;
      this.checkSeleced = index;
    },
    getLevelName(level) {
      let levelName = "";
      if (level == "1") {
        levelName = "省级";
      } else if (level == "2") {
        levelName = "市级";
      } else if (level == "3") {
        levelName = "县/区级";
      } else if (level == "4") {
        levelName = "乡/镇级";
      } else {
        levelName = "村级";
      }
      return levelName;
    },
    cencalSelectVal() {
      this.emitData = {
        zrqName: "",
        objid: "",
        type: "",
        level: "",
        zqCode: "",
      };
      this.dataList.forEach((item, index) => {
        if (this.zrqData.objid == item.objid) {
          this.checkSeleced = index;
          this.selecedZrq = item.zqName;
        }
      });
      this.$emit("getData", this.emitData);
    },
    saveSelectVal() {
      this.$emit("getData", this.emitData);
    },
  },
  watch: {
    zrqData: {
      handler: function () {
        if (this.zrqData.uid && this.zrqData.objid) {
          this.getSelectList();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.zrqSelectPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  z-index: 2005;
  .currentBox {
    width: 100%;
    height: 45px;
    line-height: 45px;
    background-color: #fff;
    padding: 0 16px;
    font-size: 15px;
    font-family: "PingFangSC-Regular", "PingFang SC";
    font-weight: 400;
    span {
      color: #4bc985;
    }
  }
  .selectBox {
    padding-top: 8px;
    height: calc(100% - 35px);
    .selectTit {
      background-color: #f6f6f6;
      height: 15px;
      font-size: 12px;
      font-family: "PingFangSC-Regular", "PingFang SC";
      font-weight: 400;
      color: #adadad;
      line-height: 15px;
      padding: 0 16px;
      margin-bottom: 10px;
    }

    ul.selectList {
      width: 100%;
      height: calc(100% - 15px);
      overflow-y: scroll;
      padding: 0 16px 100px;
      li.listInfo {
        width: 100%;
        background-color: #fff;
        margin: 10px 0;
        border-radius: 5px;
        position: relative;
        overflow: hidden;
        .infoTit {
          font-size: 15px;
          font-family: "PingFangSC-Medium", "PingFang SC";
          font-weight: 500;
          color: #37c375;
          padding: 3px 16px;
          border-bottom: 1px solid #ebedf0;
          position: relative;
        }
        .infoTit::before {
          content: "";
          position: absolute;
          width: 3px;
          height: 15px;

          background: #37c375;
          top: 6px;
          left: 7px;
        }
        .infoDetail {
          .van-cell {
            height: 25px;
            padding: 0 16px;
            margin: 8px 0;

            .van-cell__title {
              span {
                color: #8f8f8f;
              }
            }
            .van-field__control {
              text-align: right;
              color: #6f7070;
            }
          }
          .van-cell::after {
            content: none !important;
          }
          .van-cell.moreText {
            height: auto;
            min-height: 25px;
          }
        }

        .infoDetail.van-cell-group::after {
          content: none;
        }
        .selected {
          display: none;
          width: 50px;
          height: 25px;
          background-color: #4bc985;
          position: absolute;
          top: -3px;
          right: -18px;
          text-align: center;
          transform: rotate(45deg);
          -ms-transform: rotate(45deg); /* IE 9 */
          -moz-transform: rotate(45deg); /* Firefox */
          -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
          -o-transform: rotate(45deg); /* Opera */
          .selectIcon {
            color: #fff;
            font-size: 14px;
            line-height: 30px;
            font-weight: 600;
            transform: rotate(-45deg);
            -ms-transform: rotate(-45deg); /* IE 9 */
            -moz-transform: rotate(-45deg); /* Firefox */
            -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
            -o-transform: rotate(-45deg); /* Opera */
          }
        }
      }
      li.listInfo:first-child {
        margin-top: 0;
      }
      li.listInfo.active {
        .selected {
          display: block;
        }
      }
    }
  }
  .btnBox {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    .van-button {
      display: inline-block;
      width: 50%;
      height: 45px;
      line-height: 45px;
    }
  }
}
</style>